/**
 * Created by ws7 on 2017/6/12.
 */

import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
    state,
    actions,
    mutations
};